import { Link } from "@tanstack/react-router";
import { Mic, ArrowRight, Headphones } from "lucide-react";
import { PageContainer } from "@/components/Logo";
import { Button } from "@/components/ui/button";

/**
 * Shared Voice DAR cross-link callout for marketing pages.
 * Keeps the tagline and Deepgram attribution identical everywhere.
 */
export function VoiceDarCallout({ context }: { context: string }) {
  return (
    <section className="border-t border-border/60 bg-gradient-to-b from-primary/[0.05] to-transparent py-16 md:py-20">
      <PageContainer>
        <div className="mx-auto max-w-3xl rounded-2xl border border-primary/30 bg-card p-8 text-center">
          <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-primary/30 bg-primary/10 text-primary">
            <Mic className="h-6 w-6" />
          </div>
          <h2 className="font-display text-2xl font-bold md:text-3xl">MissionReady Voice DAR™</h2>
          <p className="mt-2 text-lg font-semibold text-primary">Hands free, eyes stay observing.</p>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">{context}</p>
          <div className="mt-7 flex flex-col items-center gap-4">
            <Button asChild size="lg">
              <Link to="/voice-dar">
                See Voice DAR in action <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <a
              href="https://deepgram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground transition-colors hover:text-foreground"
              aria-label="MissionReady Voice DAR transcription is powered by Deepgram (opens in new tab)"
            >
              <Headphones aria-hidden="true" className="h-4 w-4 text-primary" />
              Voice DAR transcription — powered by Deepgram
            </a>
          </div>
        </div>
      </PageContainer>
    </section>
  );
}
